/* global SOLVNET */
(function($) {
	"use strict";
	$.fn.materialPopinCgu = function(onAcceptCgu) {
		const div = $(this);

		const template = $(''
			+ '<form method="POST" action="" class="cgu-form">'
			+ '    <div class="cgu-error-message">' + SOLVNET.getLang('CGUError') + '</div>'
			+ '    <span>' + SOLVNET.getLang("CGURead1") + '</span>'
			+ '    <a class="cgu-link" href="' + getCguUrl() + '" target="_blank">' + SOLVNET.getLang("CGURead2") + '</a>'
			+ '    <div class="checkbox">'
			+ '        <label>'
			+ '             <input id="cgu-accept" name="cgu-accept" type="checkbox">'
			+ '        ' + SOLVNET.getLang("CGUAccept")
			+ '        </label>'
			+ '    </div>'
			+ '    <div class="cgu-form-buttons-bar">'
			+ '        <button disabled id="cgu-validate-btn" class="button btn btn-primary">' + SOLVNET.getLang('CGUValidate') + '</button>'
			+ '    </div>'
			+ '</form>'
		).appendTo(div);

		// https://www.nomadia-group.com/en/general-terms-and-conditions-of-use/ 
		const acceptCheckBox = template.find('#cgu-accept');
		const validateButton = template.find('#cgu-validate-btn');
		const errorMessage = template.find('.cgu-error-message');

		acceptCheckBox.change(() => {
			const isAccept = acceptCheckBox.is(':checked');
			if (isAccept) {
				validateButton.removeAttr("disabled");
			}
			else {
				validateButton.attr("disabled", "true");
			}
		});
		validateButton.click(event => {
			event.preventDefault();
			const isAccept = acceptCheckBox.is(':checked');
			if (isAccept) {
				sendGcuApproval();
			}
		});

		function logout() {
			window.location = SOLVNET.getURL('public/logout');
		}

		function getCguUrl() {
			return SOLVNET.getLang('CGULink');
		}

		function sendGcuApproval() {
			$.post(SOLVNET.getURL('cgu/accept'), {
			}).done(() => {
				if (onAcceptCgu) {
					onAcceptCgu();
				}
				close();
			}).fail(() => {
				if (onAcceptCgu) {
					onAcceptCgu();
				}
				errorMessage.show();
				// on error : show error message during 1s then close popup (avoid block user)
				setTimeout(close, 1000);
			});
		}

		function close() {
			// close popup
			div.closest('.bbm-overlay-background').remove();
		}

		div.overlayFitContent("", logout);
	};
})(window.jQuery);